import React from 'react';
import { Box, ScopedCssBaseline } from '@mui/material';
import SKUMgmtSubmissions from '../component/list/SKUMgmtSubmissions';

function TablePage(props) {

  return (
    <ScopedCssBaseline>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1.5rem',
        }}
      >
        <SKUMgmtSubmissions />
      </Box>
    </ScopedCssBaseline>);
};

export default TablePage;